
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitopanchganicab() {



    const cardData =
    {
        keyword: 'Mumbai to Panchgani Cab',
        heading: 'S9 Travels: Mumbai to Panchgani Cab',
        headingDescription: 'S9 Travels offers Mumbai to Panchgani Cab Service, ensuring a comfortable, reliable, and hassle-free journey. Whether you are planning a weekend retreat, family vacation, or adventure trip, our Innova cabs provide a smooth and enjoyable ride to the beautiful hill station. With spacious interiors, luxury features, and professional drivers, we guarantee a safe and stress-free travel experience. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Panchgani cab with S9 Travels for a seamless and memorable trip!',


        top: 'Top Places to Visit in Panchgani   with S9 Travels',

"topPlaces": [
    {
      "title": "Table Land",
      "description": "The second-largest volcanic plateau in Asia, Table Land offers breathtaking panoramic views of Panchgani and is a great spot for horse riding and trekking."
    },
    {
      "title": "Sydney Point",
      "description": "A beautiful viewpoint that offers mesmerizing views of the Krishna Valley, Dhom Dam, and the surrounding hills, especially stunning during sunrise and sunset."
    },
    {
      "title": "Parsi Point",
      "description": "A popular viewpoint known for its stunning views of the lush green valleys and the Krishna River, making it a perfect spot for photography."
    },
    {
      "title": "Devil’s Kitchen",
      "description": "A fascinating cave site linked to the legend of the Pandavas from the Mahabharata, known for its mystical atmosphere and scenic beauty."
    },
    {
      "title": "Mapro Garden",
      "description": "A must-visit for food lovers, Mapro Garden offers fresh strawberries, delicious ice creams, and a variety of fruit-based products like jams and syrups."
    },
    {
      "title": "Rajpuri Caves",
      "description": "A set of ancient caves believed to be associated with Lord Kartikeya, Rajpuri Caves have religious significance and are known for their sacred water kunds."
    },
    {
      "title": "Harrison’s Folly",
      "description": "A flat, open plateau offering stunning 360-degree views of Panchgani and the surrounding hills, perfect for adventure activities and photography."
    },
    {
      "title": "Dhom Dam",
      "description": "A serene spot offering boating and scenic views of the backwaters, Dhom Dam is ideal for a peaceful escape from the bustling tourist spots."
    },
    {
      "title": "Wai",
      "description": "A historic town near Panchgani, Wai is famous for its ancient temples, ghats, and scenic river views, making it a great cultural and spiritual getaway."
    },
    {
      "title": "Lingmala Waterfall",
      "description": "Located between Mahabaleshwar and Panchgani, Lingmala Waterfall is a breathtaking cascade best visited during the monsoon season."
    }
],

"services": [
    {
      "name": "Mumbai to Mahabaleshwar Cab Service",
      "description": "S9 Travels offers reliable and comfortable cab services from Mumbai to Mahabaleshwar. Whether you're traveling for leisure or a family trip, our cabs ensure a smooth and enjoyable journey."
    },
    {
      "name": "Book Mumbai to Mahabaleshwar Taxi",
      "description": "Booking a taxi from Mumbai to Mahabaleshwar with S9 Travels is simple and hassle-free. Choose from one-way or round-trip options and enjoy a comfortable ride to the hill station."
    },
    {
      "name": "Affordable Mumbai to Mahabaleshwar Cab",
      "description": "S9 Travels offers affordable taxi services from Mumbai to Mahabaleshwar, providing a budget-friendly way to travel in comfort and style to one of the most popular hill stations in Maharashtra."
    },
    {
      "name": "Luxury Cab from Mumbai to Mahabaleshwar",
      "description": "Travel in luxury with S9 Travels' premium cab service from Mumbai to Mahabaleshwar. Our luxury vehicles are well-maintained and equipped with top-tier amenities for a comfortable and relaxing journey."
    },
    {
      "name": "Mahabaleshwar Trip by Cab from Mumbai",
      "description": "Make your Mahabaleshwar trip special with S9 Travels' comfortable and reliable cab services. Whether it's a family getaway or a romantic holiday, our cabs ensure a pleasant and stress-free ride."
    },
    {
      "name": "Private Taxi for Mahabaleshwar from Mumbai",
      "description": "Choose S9 Travels for a private taxi from Mumbai to Mahabaleshwar. Enjoy personalized service, privacy, and a direct route to the hill station with our professional drivers."
    },
    {
      "name": "Mahabaleshwar Sightseeing by Taxi from Mumbai",
      "description": "Explore Mahabaleshwar’s scenic beauty with S9 Travels’ sightseeing taxi service. Our expert drivers will guide you to all the popular attractions, ensuring a memorable trip."
    },
    {
      "name": "Group Travel to Mahabaleshwar",
      "description": "S9 Travels provides spacious cabs for group travel from Mumbai to Mahabaleshwar. Whether it’s a family reunion or a friends’ getaway, our cabs offer the perfect solution for group transportation."
    },
    {
      "name": "Comfortable Mumbai to Mahabaleshwar Taxi Service",
      "description": "S9 Travels offers a comfortable and smooth taxi service from Mumbai to Mahabaleshwar. Our experienced drivers and well-maintained vehicles ensure a safe and relaxing journey."
    },
    {
      "name": "Mahabaleshwar Holiday by Private Taxi",
      "description": "Enjoy a holiday in Mahabaleshwar with a private taxi from Mumbai. S9 Travels provides personalized taxi services to ensure a luxurious and comfortable trip to the hill station."
    }
],

"tableData": [
  ["Mumbai to Mahabaleshwar Cab Service", "Book Mumbai to Mahabaleshwar Taxi"],
  ["Affordable Mumbai to Mahabaleshwar Cab", "Luxury Cab from Mumbai to Mahabaleshwar"],
  ["Mahabaleshwar Trip by Cab from Mumbai", "Private Taxi for Mahabaleshwar from Mumbai"],
  ["Mahabaleshwar Sightseeing by Taxi from Mumbai", "Group Travel to Mahabaleshwar"],
  ["Comfortable Mumbai to Mahabaleshwar Taxi Service", "Mahabaleshwar Holiday by Private Taxi"],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Scenic Ride",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to Panchgani cab service that ensures a smooth and relaxing journey. Our well-maintained vehicles, such as the Toyota Innova, provide ample space and air conditioning, allowing you to enjoy the scenic beauty on your way to Panchgani with ease."
  },
  {
    "WhyChooseheading": "Timely and Reliable Service",
    "WhyChoosedescription": "We understand the importance of punctuality. Our Mumbai to Panchgani cab service guarantees timely pick-ups and drop-offs. Our drivers ensure you reach your destination on time, whether it’s for a vacation, business, or a special event."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are well-versed with the route from Mumbai to Panchgani, ensuring a smooth and safe journey. With their knowledge of road conditions and traffic patterns, you can sit back and relax while they take care of the rest."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for your Mumbai to Panchgani cab service. We are committed to transparency, providing clear cost breakdowns during the booking process so you can plan your travel budget without any surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort Throughout the Journey",
    "WhyChoosedescription": "Your safety is our top priority. Our vehicles are equipped with modern safety features, including GPS tracking, airbags, and seat belts. Whether you're traveling alone, with family, or in a group, we ensure a safe and comfortable ride from Mumbai to Panchgani."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, ensuring you can book your Mumbai to Panchgani cab at any time that suits your schedule. Whether it’s an early morning departure or a late-night return, we are here to provide a hassle-free experience."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans for Your Needs",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you wish to make stops along the way, need a personalized itinerary, or have special requirements, we offer customizable travel plans for your Mumbai to Panchgani journey, tailored to your needs."
  },
  {
    "WhyChooseheading": "Easy and Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab from Mumbai to Panchgani with S9 Travels is easy and hassle-free. You can book your ride online via our website or mobile app, or contact our customer service team for personalized assistance, ensuring a smooth booking experience."
  }
]








    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Panchgani with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Panchgani is easy! You can book your ride through our website or app, or contact our customer service team for personalized assistance in planning your trip to this beautiful hill station.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Panchgani travel?',
            answer: 'We offer a variety of vehicles for your Mumbai to Panchgani journey, including sedans, SUVs, and premium vehicles like the Toyota Innova. Whether you’re traveling alone or with a group, we have the perfect vehicle to ensure your comfort.',
          },
          {
            question: 'How long does the journey from Mumbai to Panchgani take?',
            answer: 'The journey from Mumbai to Panchgani typically takes around 4.5 to 5.5 hours, depending on traffic and road conditions. Our experienced drivers ensure a smooth and enjoyable ride through scenic routes.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Panchgani?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes to Panchgani. They ensure a safe, smooth, and enjoyable journey through the picturesque hills.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Panchgani?',
            answer: 'Yes, we offer round-trip bookings for your Mumbai to Panchgani journey. You can plan your return trip according to your schedule, and we will ensure a smooth and timely journey back to Mumbai.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Panchgani cab service?',
            answer: 'The fare for Mumbai to Panchgani travel varies based on the type of vehicle, trip duration, and any specific requirements. Contact us for a customized quote to ensure you get the best rate for your trip.',
          },
          {
            question: 'Do you provide pick-up services from Mumbai airport or hotels for Panchgani trips?',
            answer: 'Yes, we provide convenient pick-up services from Mumbai airport or your hotel. Our driver will ensure a smooth transfer, making your journey to Panchgani comfortable and stress-free right from the start.',
          },
          {
            question: 'Can I request additional stops on the way to Panchgani?',
            answer: 'Yes, we can accommodate additional stops for sightseeing or breaks during your journey to Panchgani. Let us know during booking, and we’ll customize the trip to include your preferred stops along the way.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Panchgani trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated upfront when you book your trip. We ensure full transparency in pricing to make your trip hassle-free.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Panchgani cab service?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for your Mumbai to Panchgani journey. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure a smooth, safe, and enjoyable trip to this beautiful hill station.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Amit Desai',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Mumbai to Panchgani with S9 Travels was delightful. The driver was courteous, the vehicle was comfortable, and the scenic drive was a bonus. We had a smooth and enjoyable journey, and I highly recommend their services for anyone traveling to Panchgani.”',
        },
        {
          name: 'Mrs. Priya Mehra',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I had a fantastic experience with S9 Travels for my trip from Mumbai to Panchgani. The driver was experienced, and the vehicle was in great condition. The ride was smooth and relaxing, and we reached Panchgani in no time. I would definitely book with them again!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Panchgani Cab",
        "description": "Book affordable and reliable Mumbai to Panchgani cab services for one-way trips, round trips, luxury cabs, and group travel. S9 Travels offers private taxi rides for a comfortable and scenic journey from Mumbai to Panchgani, including sightseeing tours and holiday trips.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
     
      
      
      


    return (
        <div>
        
        <Helmet>
        <title>Mumbai to Panchgani Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai to Panchgani taxi services, including one-way, round-trip, and luxury cabs. Comfortable and affordable transport for sightseeing tours, group travel, and holidays from Mumbai to Panchgani with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
       
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/55.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopanchganicab;